import { render, staticRenderFns } from "./headerBottom.vue?vue&type=template&id=60d4cf54"
import script from "./headerBottom.vue?vue&type=script&lang=js"
export * from "./headerBottom.vue?vue&type=script&lang=js"
import style0 from "./headerBottom.vue?vue&type=style&index=0&id=60d4cf54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports